import { Amount } from '@mews-commander/types';
import { Icon, IconName, Stack } from '@optimus-web/core';
import { LocalizedCurrencyValue } from '@mews/framework';

interface AmountDueProps {
    value: Amount;
    isNegative: boolean;
}

const InlineAmountDue = ({ value, isNegative }: AmountDueProps) => (
    <Stack inline spacing="50">
        {isNegative ? <Icon value={IconName.Return} /> : null}
        <LocalizedCurrencyValue value={value} />
    </Stack>
);

export default InlineAmountDue;
